'use strict';
(() => {
  const frame=document.querySelector('.mncs-frame');if(!frame)return;
  const notice=document.createElement('p');notice.className='mncs-note mncs-production-notice';notice.style.cssText='font-size:14px;line-height:1.5;max-width:1000px;margin:12px auto;padding:12px 16px;border:1px solid #e5d9e3;border-radius:10px;background:#fff8fc;color:#52505b';
  notice.textContent=NeonRushPolicy.copy+' Requested dates are confirmed after payment and final artwork approval.';frame.after(notice);
  // The configured checkout handler owns timing validation for ordinary and
  // designer-finished orders, before it makes any cart request.
})();
